import React from "react";

interface BeneficiarySkeletonProps {
  count?: number;
}

const BeneficiarySkeleton: React.FC<BeneficiarySkeletonProps> = ({
  count = 2,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="animate-pulse">
          <div className="p-[32px]">
            {/* Beneficiary name */}
            <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>

            {/* Relationship and Birth date section */}
            <div className="flex justify-between mt-2">
              <div>
                <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
                <div className="h-5 bg-gray-200 rounded w-16"></div>
              </div>
              <div>
                <div className="h-4 bg-gray-200 rounded w-16 mb-2"></div>
                <div className="h-5 bg-gray-200 rounded w-20"></div>
              </div>
            </div>
          </div>
          {index < count - 1 && <hr />}
        </div>
      ))}
    </>
  );
};

export default BeneficiarySkeleton;
